import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import Currency from '../Currency'

import {getNumberBase, formatValueByBase, formatValue} from './helpers'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class FormattedNumber extends PureComponent {
    static propTypes = {
        currency: PropTypes.string,
        currencyStyle: PropTypes.object,
        customBase: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        decimalPlaces: PropTypes.number,
        displayCurrency: PropTypes.bool,
        displayNegativesRed: PropTypes.bool,
        displayUnits: PropTypes.bool,
        dontFormatValue: PropTypes.bool,
        emptyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        unitsStyle: PropTypes.object,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        valueStyle: PropTypes.object,
    }

    static defaultProps = {
        currency: 'czk',
        customBase: null,
        decimalPlaces: 0,
        displayCurrency: false,
        displayNegativesRed: false,
        displayUnits: false,
        dontFormatValue: false,
        emptyValue: '-',
    }

    formatNumber = (inputValue) => {
        const {
            currency,
            currencyStyle,
            customBase,
            decimalPlaces,
            displayCurrency,
            displayNegativesRed,
            displayUnits,
            dontFormatValue,
            emptyValue,
            unitsStyle,
            valueStyle,
            dontUseBase,
        } = this.props

        let base = getNumberBase(inputValue)
        if (!_.isNil(customBase) && typeof customBase === 'number') base = getNumberBase(customBase)
        if (!_.isNil(customBase) && typeof customBase === 'object') base = customBase

        if (dontFormatValue) {
            return (
                <span className={classnames('cstm-frmtd-vl', displayNegativesRed && inputValue < 0 && 'negative')}>
                    <span className={'value'} style={{ ...valueStyle }}>
                        {!_.isNil(inputValue) ? inputValue : emptyValue}
                    </span>
                    {displayUnits && _.get(base, 'translate') && !_.isNil(inputValue) && (
                        <span className={'units'} style={{ ...unitsStyle }}>
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.${_.get(base, 'translate')}`}
                                defaultMessage={' '}
                            />
                        </span>
                    )}
                    {displayCurrency && !_.isNil(inputValue) && <Currency currency={currency} style={currencyStyle} />}
                </span>
            )
        }

        if (dontUseBase) {
            return (
                <span className={classnames('cstm-frmtd-vl', displayNegativesRed && inputValue < 0 && 'negative')}>
                <span className={'value'} style={{ ...valueStyle }}>
                    {formatValue(inputValue, decimalPlaces, emptyValue)}
                </span>
                    {displayUnits && _.get(base, 'translate') && !_.isNil(inputValue) && (
                        <span className={'units'} style={{ ...unitsStyle }}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.${_.get(base, 'translate')}`} defaultMessage={' '} />
                    </span>
                    )}
                    {displayCurrency && !_.isNil(inputValue) && <Currency currency={currency} style={currencyStyle} />}
            </span>
            )
        }


        return (
            <span className={classnames('cstm-frmtd-vl', displayNegativesRed && inputValue < 0 && 'negative')}>
                <span className={'value'} style={{ ...valueStyle }}>
                    {formatValueByBase(inputValue, _.get(base, 'base'), decimalPlaces, emptyValue)}
                </span>
                {displayUnits && _.get(base, 'translate') && !_.isNil(inputValue) && (
                    <span className={'units'} style={{ ...unitsStyle }}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.${_.get(base, 'translate')}`} defaultMessage={' '} />
                    </span>
                )}
                {displayCurrency && !_.isNil(inputValue) && <Currency currency={currency} style={currencyStyle} />}
            </span>
        )
    }

    render() {
        const { value } = this.props

        return this.formatNumber(value)
    }
}
